class ClipboardManager {
  copy = (str) => {
    return navigator.clipboard.writeText(str);
  };

  isImageCopySupported = () => {
    return Boolean(navigator.clipboard && navigator.clipboard.write) && typeof ClipboardItem !== "undefined";
  };

  copyImage = (blob) => {
    return navigator.clipboard.write([new ClipboardItem({ [blob.type]: blob })]);
  };
}

export const clipboardManager = new ClipboardManager();
